import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { SnapshotProvider } from './context/SnapshotContext';
import { ScrollToTop } from './components/ScrollToTop';
import PortfolioPage from './pages/PortfolioPage';
import CaseStudy from './pages/CaseStudy';
import AdminSnapshots from './pages/AdminSnapshots';

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <ScrollToTop />
                <SnapshotProvider>
                    <Routes>
                        <Route path="/" element={<PortfolioPage />} />
                        <Route path="/portfolio/:slug" element={<CaseStudy />} />
                        <Route path="/admin/snapshots" element={<AdminSnapshots />} />
                    </Routes>
                </SnapshotProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
